// src/components/Register.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

/* ============================================================
   LISTE DES PAYS AUTORISÉS (indicatifs + noms)
   ============================================================ */
const AUTHORIZED_COUNTRIES = [
  { name: 'Bénin', code: '+229' },
  { name: 'Burkina Faso', code: '+226' },
  { name: 'Cameroun', code: '+237' },
  { name: 'Centrafrique', code: '+236' },
  { name: 'Congo (Rép. du Congo)', code: '+242' },
  { name: 'Côte d\'Ivoire', code: '+225' },
  { name: 'Djibouti', code: '+253' },
  { name: 'Gabon', code: '+241' },
  { name: 'Gambie', code: '+220' },
  { name: 'Ghana', code: '+233' },
  { name: 'Guinée', code: '+224' },
  { name: 'Guinée-Bissau', code: '+245' },
  { name: 'Guinée équatoriale', code: '+240' },
  { name: 'Kenya', code: '+254' },
  { name: 'Libéria', code: '+231' },
  { name: 'Mali', code: '+223' },
  { name: 'Niger', code: '+227' },
  { name: 'Nigeria', code: '+234' },
  { name: 'Pays-Bas', code: '+31' },
  { name: 'RD Congo', code: '+243' },
  { name: 'Sénégal', code: '+221' },
  { name: 'Sierra Leone', code: '+232' },
  { name: 'Soudan du Sud', code: '+211' },
  { name: 'Tchad', code: '+235' },
  { name: 'Togo', code: '+228' }
].sort((a, b) => a.name.localeCompare(b.name));

/* ============================================================
   COMPOSANT REGISTER
   ============================================================ */
const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    password2: '',
    countryCode: AUTHORIZED_COUNTRIES[0].code,
    phoneNumber: '',
    dateOfBirth: ''
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const { firstName, lastName, email, password, password2, countryCode, phoneNumber, dateOfBirth } = formData;

  const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    if (password !== password2) {
      setMessage('Les mots de passe ne correspondent pas.');
      return;
    }

    try {
      const config = { headers: { 'Content-Type': 'application/json' } };
      const fullPhoneNumber = `${countryCode}${phoneNumber}`;

      const body = JSON.stringify({
        firstName,
        lastName,
        email,
        password,
        phoneNumber: fullPhoneNumber,
        dateOfBirth
      });

      // URL sans espace
      const res = await axios.post('https://api.blackroq.pro/api/auth/register', body, config);
      localStorage.setItem('token', res.data.token);
      navigate('/dashboard');
    } catch (err) {
      console.error(err.response?.data || err);
      setMessage(err.response?.data?.message || 'Erreur lors de l\'inscription');
    }
  };

  const handleGoogleLogin = () => {
    // URL sans espace
    window.location.href = 'https://api.blackroq.pro/api/auth/google';
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow p-4">
            <h1 className="text-center mb-4">S'inscrire</h1>
            {message && <div className="alert alert-danger">{message}</div>}

            <form onSubmit={onSubmit}>
              <input type="text" className="form-control mb-2" placeholder="Prénom" name="firstName" value={firstName} onChange={onChange} required />
              <input type="text" className="form-control mb-2" placeholder="Nom de famille" name="lastName" value={lastName} onChange={onChange} required />
              <input type="email" className="form-control mb-2" placeholder="Adresse e-mail" name="email" value={email} onChange={onChange} required />
              <input type="password" className="form-control mb-2" placeholder="Mot de passe" name="password" value={password} onChange={onChange} required minLength="6" />
              <input type="password" className="form-control mb-2" placeholder="Confirmer le mot de passe" name="password2" value={password2} onChange={onChange} required minLength="6" />

              {/* indicatifs autorisés uniquement */}
              <div className="input-group mb-2">
                <select className="form-select" name="countryCode" value={countryCode} onChange={onChange} required style={{ maxWidth: '150px' }}>
                  {AUTHORIZED_COUNTRIES.map(c => (
                    <option key={c.code} value={c.code}>
                      {c.code} ({c.name})
                    </option>
                  ))}
                </select>
                <input type="text" className="form-control" placeholder="Numéro de téléphone" name="phoneNumber" value={phoneNumber} onChange={onChange} required />
              </div>
              <div className="form-text">Veuillez sélectionner votre indicatif. Inscription géographiquement limitée.</div>

              {/* date avec placeholder + texte d’aide */}
              <input
                type="date"
                className="form-control mb-2"
                name="dateOfBirth"
                value={dateOfBirth}
                onChange={onChange}
                required
                placeholder="jj/mm/aaaa"
              />
              <div className="form-text">Format : jj/mm/aaaa</div>

              <div className="d-grid gap-2 mt-3">
                <button type="submit" className="btn btn-primary">S'inscrire</button>
                <button type="button" className="btn btn-danger" onClick={handleGoogleLogin}>
                  <i className="fab fa-google"></i> S'inscrire avec Google
                </button>
              </div>
            </form>

            <p className="mt-3 text-center">
              Vous avez déjà un compte ? <Link to="/">Connectez-vous</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;